export default __webpack_public_path__ + "static/media/lump-sum-repayment-table.d385b8cb.svg";